var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServiceCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 2528"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.1666 26.7895C22.0986 26.7895 26.0968 22.7913 26.0968 17.8593C26.0968 12.9274 22.0986 8.9292 17.1666 8.9292C12.2347 8.9292 8.23651 12.9274 8.23651 17.8593C8.23651 22.7913 12.2347 26.7895 17.1666 26.7895Z",
    fill: "#5D7AFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M28.2417 21.3344H26.2927V14.9925C26.2927 10.0015 22.2401 5.94896 17.2492 5.94896C12.2582 5.94896 8.20558 10.0015 8.20558 14.9925V21.3344H6.26694V14.9925C6.26694 8.92911 11.196 4 17.2492 4C23.3023 4 28.2314 8.92911 28.2314 14.9822V21.3344H28.2417Z",
    fill: "#68DCFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M25.6431 14.5698C25.6431 14.1677 26.004 13.8686 26.3959 13.9305C28.7264 14.2914 30.5 16.3125 30.5 18.7359C30.5 21.1695 28.7161 23.1803 26.3959 23.5412C26.004 23.6031 25.6431 23.304 25.6431 22.9019V14.5698Z",
    fill: "#2820FF"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M14.5062 21.8501H11.7632C10.0721 21.8501 8.70058 20.4786 8.70058 18.7874V14.5698C8.70058 14.1677 8.33966 13.8686 7.94781 13.9305C5.61731 14.2914 3.83334 16.3022 3.83334 18.7358C3.83334 21.1695 5.61731 23.1803 7.93749 23.5412C8.05093 23.5618 14.5474 23.5103 14.5474 23.5103C15.0321 23.5103 15.424 23.0875 15.3724 22.5925C15.3312 22.1697 14.9393 21.8501 14.5062 21.8501Z",
    fill: "#2820FF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceCall);
export default __webpack_public_path__ + "static/media/service-call.bb7ddf612f4b7744c37ed40aef60895b.svg";
export { ForwardRef as ReactComponent };